export default class Alert {
  constructor({ message, type, icon } = {}) {
    this.message = message || '';
    this.type = type || 'error';
    this.icon = icon || true;
    this.show = this.message.length > 1 ? true : false;
  }
}

export function setAlert({ message, type, icon } = {}) {
  return {
    message: message || '',
    type: type || 'error',
    icon: icon || undefined,
    show: message && message.length > 1 ? true : false
  };
}
